window.addEventListener('load', function () {

  var mediaCol = document.querySelector('.product__media-wrapper');
  var infoCol  = document.querySelector('.product__info-wrapper');
  var infoPage = document.querySelector('body');

  if (!mediaCol || !infoCol) return;

  var offsetMedia = 0;
  var offsetInfo  = 0;

  function colsAtTop(col) {
    return col.getBoundingClientRect().top <= 0;
  }

  function onPageWheel(e) {
    if (window.innerWidth < 750) return;
    if ((colsAtTop(mediaCol) || colsAtTop(infoCol)) && 
        !(offsetMedia >= mediaCol.scrollHeight - mediaCol.clientHeight && 
          offsetInfo  >= infoCol.scrollHeight  - infoCol.clientHeight)) {
      e.preventDefault();
    }
  }
  infoPage.addEventListener('wheel', function (e) { onPageWheel(e); }, { passive: false });

  function onWheel(e, isPrimMedia) {
    var delta  = e.deltaY;
    var col    = isPrimMedia ? mediaCol : infoCol;
    var max    = col.scrollHeight - col.clientHeight;
    var offset = isPrimMedia ? offsetMedia : offsetInfo;

    if (delta > 0) { // w dół

      // Faza 1 — przewiń stronę tylko do top=0
      if (!colsAtTop(col)) {
        e.preventDefault();
        var colTop = col.getBoundingClientRect().top;
        window.scrollBy(0, Math.min(delta, colTop));
      }
      // Faza 2 — przewijaj tylko kolumnę pod kursorem
      if (offset < max) {
        e.preventDefault();
        offset = Math.min(max, offset + delta);
      } else {
        // Kolumna skończona — przewijaj drugą
        var otherCol    = isPrimMedia ? infoCol  : mediaCol;
        var otherMax    = otherCol.scrollHeight - otherCol.clientHeight;
        var otherOffset = isPrimMedia ? offsetInfo : offsetMedia;

        if (otherOffset < otherMax) {
          e.preventDefault();
          otherOffset = Math.min(otherMax, otherOffset + delta);
        } else {
          e.preventDefault();
          window.scrollBy(0, delta);
        }

        if (isPrimMedia) offsetInfo  = otherOffset;
        else             offsetMedia = otherOffset;

        otherCol.scrollTop = otherOffset;
        return;
      }
      if (isPrimMedia) offsetMedia = offset;
      else             offsetInfo  = offset;
      col.scrollTop = offset;

    } else { // w górę

      var colBottom = col.getBoundingClientRect().bottom;

      // Dolna krawędź powyżej ekranu — przewiń stronę w górę
      if (colBottom < window.innerHeight) {
        e.preventDefault();
        window.scrollBy(0, Math.max(delta, colBottom - window.innerHeight));
        return;
      }

      // Faza 2 — przewijaj kolumnę pod kursorem
      if (offset > 0) {
        e.preventDefault();
        offset = Math.max(0, offset + delta);
      } else {
        // Kolumna na górze — przewijaj drugą
        var otherCol    = isPrimMedia ? infoCol  : mediaCol;
        var otherMax    = otherCol.scrollHeight - otherCol.clientHeight;
        var otherOffset = isPrimMedia ? offsetInfo : offsetMedia;

        if (otherOffset > 0) {
          e.preventDefault();
          otherOffset = Math.max(0, otherOffset + delta);
        }
        // Obie na górze — puść scroll strony

        if (isPrimMedia) offsetInfo  = otherOffset;
        else             offsetMedia = otherOffset;
        otherCol.scrollTop = otherOffset;
        return;
      }

      if (isPrimMedia) offsetMedia = offset;
      else             offsetInfo  = offset;
      col.scrollTop = offset;
    }
  }

  mediaCol.addEventListener('wheel', function (e) {
    if (window.innerWidth < 750) return;
    onWheel(e, true);
  }, { passive: false });

  infoCol.addEventListener('wheel', function (e) {
    if (window.innerWidth < 750) return;
    onWheel(e, false);
  }, { passive: false });

});